import { Math as PhaserMath } from 'phaser';

/**
 * Faixa rolável por arrasto (toque), num eixo só. O conteúdo vai num
 * Container recortado por máscara; `moveu` distingue arrasto de toque para
 * os itens internos não dispararem clique no fim de uma rolagem.
 */
export class AreaRolavel {
    /**
     * @param {Phaser.Scene} scene
     * @param {{x:number, y:number, largura:number, altura:number, eixo:'x'|'y'}} config
     */
    constructor (scene, { x, y, largura, altura, eixo = 'x' }) {
        this.scene = scene;
        this.area = { x, y, largura, altura };
        this.eixo = eixo;
        this.tamanhoConteudo = 0;
        this.moveu = false;
        this.ativa = true;

        this.conteudo = scene.add.container(x, y);
        const forma = scene.make.graphics({ add: false });
        forma.fillStyle(0xffffff).fillRect(x, y, largura, altura);
        this.conteudo.setMask(forma.createGeometryMask());

        // `worldX/worldY`, não `x/y`: com o canvas em ZOOM× os brutos vêm em pixels do canvas e a
        // área está em coordenadas de desenho (1280×800). Sem zoom os dois coincidem.
        const mundo = (ponteiro) => (eixo === 'x' ? ponteiro.worldX : ponteiro.worldY);

        const dentro = (ponteiro) => this.ativa
            && ponteiro.worldX >= x && ponteiro.worldX <= x + largura
            && ponteiro.worldY >= y && ponteiro.worldY <= y + altura;

        const aoBaixar = (ponteiro) => {
            this.moveu = false;
            this.arrastando = dentro(ponteiro);
            this.origem = mundo(ponteiro);
            this.inicio = this.conteudo[eixo];
        };
        const aoMover = (ponteiro) => {
            if (!this.arrastando || !ponteiro.isDown) return;
            const delta = mundo(ponteiro) - this.origem;
            if (Math.abs(delta) > 8) this.moveu = true;
            if (this.moveu) this.rolarPara(this.inicio + delta);
        };
        const aoSoltar = () => { this.arrastando = false; };

        scene.input.on('pointerdown', aoBaixar);
        scene.input.on('pointermove', aoMover);
        scene.input.on('pointerup', aoSoltar);
        this.desligar = () => {
            scene.input.off('pointerdown', aoBaixar);
            scene.input.off('pointermove', aoMover);
            scene.input.off('pointerup', aoSoltar);
        };
        scene.events.once('shutdown', this.desligar);
    }

    /**
     * Para cenas que redesenham a área: tira os ouvintes de ponteiro e destrói o conteúdo, sem esperar o
     * `shutdown` da cena (sem isto, cada redesenho deixaria três ouvintes a mais). Pode ser chamada de novo.
     */
    destruir () {
        this.ativa = false;
        this.arrastando = false;
        this.desligar?.();
        this.scene.events.off('shutdown', this.desligar);
        this.conteudo?.destroy();
    }

    /** Diz se o ponteiro está na área visível (itens fora da máscara ainda recebem toque). */
    contem (ponteiro) {
        const { x, y, largura, altura } = this.area;
        return this.ativa && ponteiro.worldX >= x && ponteiro.worldX <= x + largura
            && ponteiro.worldY >= y && ponteiro.worldY <= y + altura;
    }

    definirTamanho (tamanho) {
        this.tamanhoConteudo = tamanho;
        this.rolarPara(this.conteudo[this.eixo]);
    }

    rolarPara (posicao) {
        const origem = this.area[this.eixo];
        const visivel = this.eixo === 'x' ? this.area.largura : this.area.altura;
        const minimo = origem - Math.max(0, this.tamanhoConteudo - visivel);
        this.conteudo[this.eixo] = PhaserMath.Clamp(posicao, minimo, origem);
    }
}
